import { TypographyProps } from "@material-tailwind/react";

export const typographyStyles = {
  h1: "text-4xl font-bold font-noto",
  h2: "text-3xl font-bold font-noto",
  h3: "text-2xl font-bold font-noto",
  h4: "text-xl font-bold font-noto",
  h5: "text-lg font-bold font-noto",
  h6: "text-base font-bold font-noto",
  paragraph: "text-base font-normal font-noto",
  small: "text-sm font-normal font-noto",
  tiny: "text-xs font-normal font-noto",
}; 